// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/filter-bar/filter-bar.less
// module id = 3360
// module chunks = 0